import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { apiGet } from 'app/shared-components/util/restAPI';

const referenceCodeAdapter = createEntityAdapter({
  selectId: (code) => `${code.codeSystem}:${code.code}`
});

export const fetchReferenceCodes = createAsyncThunk(
  'referenceCodes/fetchReferenceCodes',
  async (codeSystem) => {
    const apiName = 'CoreAPI';
    const path = `/x2/referencecode/bycodesystem/${codeSystem}`;
    const options = { headers: {}, response: false };
    return await apiGet(apiName, path, options);
  }
);

export const searchReferenceCodes = createAsyncThunk(
  'referenceCodes/searchReferenceCodes',
  async ({ codeSystem, searchText, limit = 20 }) => {
    const apiName = 'CoreAPI';
    const path = `/x2/referencecode/search?codeSystem=${encodeURIComponent(codeSystem)}&searchText=${encodeURIComponent(searchText)}&limit=${limit}`;
    const options = { headers: {}, response: false };
    return await apiGet(apiName, path, options);
  }
);

const referenceCodesSlice = createSlice({
  name: 'referenceCodes',
  initialState: referenceCodeAdapter.getInitialState({
    loading: false,
    bySystem: {}
  }),
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchReferenceCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReferenceCodes.fulfilled, (state, action) => {
        state.loading = false;
        const codeSystem = action.meta.arg;
        state.bySystem[codeSystem] = action.payload.map(c => `${c.codeSystem}:${c.code}`);
        referenceCodeAdapter.setMany(state, action.payload);
      })
      .addCase(fetchReferenceCodes.rejected, (state) => {
        state.loading = false;
      });
  }
});

const { selectById, selectAll } = referenceCodeAdapter.getSelectors();

export const selectCodesBySystem = (codeSystem) => state => {
  const codeIds = state.referenceCodes.bySystem[codeSystem] || [];
  return codeIds.map(id => selectById(state.referenceCodes, id)).filter(Boolean);
};

export const selectCodeById = (codeSystem, code) => state => 
  selectById(state.referenceCodes, `${codeSystem}:${code}`);

export const selectCodesLoading = state => state.referenceCodes.loading;

export default referenceCodesSlice.reducer;
